import React from 'react';
import { Text, Stack, Icon, Image, ImageFit } from '@fluentui/react';
import COLOR from "../../Styles/Colors";
import SyncLoader from 'react-spinners/SyncLoader'

class PageLoading extends React.PureComponent {
    render() {
        return (
            <Stack className='position-absolute' style={styles.containerLogin}>
                <Stack style={styles.containerHeader}>
                    <Image
                        src={require("../../Assets/icon.png")}
                        imageFit={ImageFit.contain}
                        width={50}
                        height={50}
                    />
                    <Text style={styles.title} >Cổng thông tin VNPT ILIS</Text>
                </Stack>
                <Stack style={styles.modal}>
                    <Stack style={styles.headerModal} >
                        <Stack style={styles.headerRow} />
                        <Stack style={{ flexDirection: 'row', marginRight: 10 }}>
                            <Icon iconName='LocationFill' styles={styles.titleIcon} />
                            <Icon iconName='LocationFill' styles={styles.titleIcon} />
                        </Stack>
                    </Stack>
                    <Stack style={styles.body}>
                        <SyncLoader color={'blue'} size={15} />
                        <Text style={{ color: 'blue', marginTop: 30 }}>Đang tải dữ liệu...</Text>
                    </Stack>
                </Stack>
            </Stack>
        )
    }
}

export default PageLoading;

const styles = {
    containerHeader: {
        marginTop: '-5%',
        marginBottom: 20,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: 450
    },
    spinner: {
        root: {
            fontSize: 50
        }
    },
    containerLogin: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#A9E2F3',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        width: '80%',
        maxWidth: 470,
        backgroundColor: 'white',
        height: 300,
        borderRadius: 10,
        zIndex: 1,
        marginTop: 10
    },
    headerModal: {
        backgroundColor: '#2f495c',
        width: '100%',
        height: 30,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row'
    },
    titleIcon: {
        root: {
            color: COLOR.white,
            fontSize: 22,
            marginRight: 5
        }
    },
    headerRow: {
        backgroundColor: 'white',
        height: 15,
        width: '65%',
        marginLeft: 20,
        borderRadius: 5
    },
    body: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10
    },
    title: {
        fontSize: 24,
        marginLeft: 20,
        color: COLOR.blue,
        fontWeight: 'bold'
    }

};
